const salesReps = [
  {
    name: "Corrine Nicholls",
    phoneNumber: "+1 905-912-1590",
    email: "corrine@craft360.ca",
  },
  {
    name: "Liam Jones",
    phoneNumber: "+1 416-528-2511",
    email: "liam@craft360.ca",
  },
  {
    name: "Mergim Shena",
    phoneNumber: "+1 647-607-0815",
    email: "mergim@craft360.ca",
  },
  {
    name: "Isaac Cousineau",
    phoneNumber: "+1 905-246-5731",
    email: "isaac@craft360.ca",
  },
  {
    name: "Chris Anderson",
    phoneNumber: "+1 647-244-0455",
    email: "chris@craft360.ca",
  },
  {
    name: "Ozz Baker",
    phoneNumber: "+1 647-502-2537",
    email: "ozz@craft360.ca",
  },
    {
    name: "Thomas Heffernan",
    phoneNumber: "+1 416-899-9183",
    email: "thomas@craft360.ca",
  },
    {
    name: "Duane Fagel",
    phoneNumber: "+1 519-241-9302",
    email: "duane@craft360.ca",
  },
    {
    name: "Tek Ma",
    phoneNumber: "+1 613-220-2828",
    email: "tek.ma@live.com",
  },
  {
    name: "West Wind",
    phoneNumber: "+1 705-497-4646",
    email: "brian@westwindtradingco.ca",
  },
];

export default salesReps;
